import Stack, { type StackProps } from "@mui/material/Stack";
import robotImage from "@repo/ui/assets/images/robot.jpg";
import { type FC } from "react";
import { BgImage } from "../Image/BgImage";

const ErrorContent: FC<StackProps> = ({ children, sx, ...rest }) => {
	return (
		<Stack sx={{ flexGrow: 1, justifyContent: "center", my: 4 }}>
			<Stack
				spacing={7}
				sx={{
					maxWidth: { md: 450, xs: "unset" },
					minHeight: 450,
					mb: { md: 0, xs: 8 },
					mx: { md: "auto !important", xs: 4 },
					...sx,
				}}
				{...rest}
			>
				<BgImage
					image={{ src: robotImage }}
					style={{
						backgroundSize: "contain",
						flexGrow: 1,
						display: "flex",
					}}
				>
					<Stack sx={{ flexGrow: 1 }} justifyContent="space-around">
						<Stack gap={5}>{children}</Stack>
					</Stack>
				</BgImage>
			</Stack>
		</Stack>
	);
};

export default ErrorContent;
